import { useAuth0 } from '@auth0/auth0-react';
import { Typography } from '@remarkable/ark-web';
import { createFileRoute } from '@tanstack/react-router';
import { Button } from 'src/components';

export const Route = createFileRoute('/_public/method-not-supported')({
  component: MethodNotSupported,
});

function MethodNotSupported() {
  const auth = useAuth0();
  return (
    <div data-cy="error-page" className="w-full bg-neutral-light-2">
      <div className="m-auto flex max-w-screen-md flex-col items-center gap-24 px-24 py-64 md:px-64 lg:py-128">
        <h1 className="text-center heading-lg">Oops!</h1>
        <p className="my-0 text-center heading-sm">404 - Page not found</p>
        <Typography variant="body-md" className="text-center">
          If your identity provider has redirected you to this page, please use
          the login button below to login.
        </Typography>
        <Button
          className="mt-12"
          variant="primary"
          onClick={() => auth.logout()}
        >
          Login
        </Button>
      </div>
    </div>
  );
}
